/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import type {
  BadRequestResponse,
  ConflictResponse,
  DeleteSuccessDTO,
  ForbiddenResponse,
  GetPosParams,
  InternalServerErrorResponse,
  PaginatedPosListItemsDTO,
  PosCreateDTO,
  PosCustomerNumberGetDTO,
  PosDTO,
  PosListItemDTO,
  PosUpdateDTO,
  SearchAllPosParams,
  UnauthorizedResponse,
} from "../../model";
import { customFetchInstance } from "../../../custom-fetch-instance";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Returns all pos matching the filter criteria. All given filter will be combined as AND criteria
 * @summary Returns a paginated List of all pos
 */
export type getPosResponse = {
  data: PaginatedPosListItemsDTO;
  status: number;
};

export const getGetPosUrl = (audiologistId: string, params?: GetPosParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `http://localhost:8080/platform/v1/audiologists/${audiologistId}/pos?${normalizedParams.toString()}`
    : `http://localhost:8080/platform/v1/audiologists/${audiologistId}/pos`;
};

export const getPos = async (
  audiologistId: string,
  params?: GetPosParams,
  options?: RequestInit
): Promise<getPosResponse> => {
  return customFetchInstance<Promise<getPosResponse>>(
    getGetPosUrl(audiologistId, params),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetPosQueryKey = (
  audiologistId: string,
  params?: GetPosParams
) => {
  return [
    `http://localhost:8080/platform/v1/audiologists/${audiologistId}/pos`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPosQueryOptions = <
  TData = Awaited<ReturnType<typeof getPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: GetPosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPos>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPosQueryKey(audiologistId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPos>>> = ({
    signal,
  }) => getPos(audiologistId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!audiologistId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getPos>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetPosQueryResult = NonNullable<Awaited<ReturnType<typeof getPos>>>;
export type GetPosQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetPos<
  TData = Awaited<ReturnType<typeof getPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params: undefined | GetPosParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPos>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPos>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPos<
  TData = Awaited<ReturnType<typeof getPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: GetPosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPos>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPos>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPos<
  TData = Awaited<ReturnType<typeof getPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: GetPosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPos>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a paginated List of all pos
 */

export function useGetPos<
  TData = Awaited<ReturnType<typeof getPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: GetPosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPos>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPosQueryOptions(audiologistId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPosSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: GetPosParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPos>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPosQueryKey(audiologistId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPos>>> = ({
    signal,
  }) => getPos(audiologistId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!audiologistId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPos>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPosSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPos>>
>;
export type GetPosSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetPosSuspense<
  TData = Awaited<ReturnType<typeof getPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params: undefined | GetPosParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPos>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPosSuspense<
  TData = Awaited<ReturnType<typeof getPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: GetPosParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPos>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPosSuspense<
  TData = Awaited<ReturnType<typeof getPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: GetPosParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPos>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a paginated List of all pos
 */

export function useGetPosSuspense<
  TData = Awaited<ReturnType<typeof getPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: GetPosParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPos>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPosSuspenseQueryOptions(
    audiologistId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new pos
 * @summary Creates a new pos
 */
export type createPosResponse = {
  data: PosDTO;
  status: number;
};

export const getCreatePosUrl = (audiologistId: string) => {
  return `http://localhost:8080/platform/v1/audiologists/${audiologistId}/pos`;
};

export const createPos = async (
  audiologistId: string,
  posCreateDTO: PosCreateDTO,
  options?: RequestInit
): Promise<createPosResponse> => {
  return customFetchInstance<Promise<createPosResponse>>(
    getCreatePosUrl(audiologistId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(posCreateDTO),
    }
  );
};

export const getCreatePosMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPos>>,
    TError,
    { audiologistId: string; data: PosCreateDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPos>>,
  TError,
  { audiologistId: string; data: PosCreateDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPos>>,
    { audiologistId: string; data: PosCreateDTO }
  > = (props) => {
    const { audiologistId, data } = props ?? {};

    return createPos(audiologistId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePosMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPos>>
>;
export type CreatePosMutationBody = PosCreateDTO;
export type CreatePosMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Creates a new pos
 */
export const useCreatePos = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPos>>,
    TError,
    { audiologistId: string; data: PosCreateDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPos>>,
  TError,
  { audiologistId: string; data: PosCreateDTO },
  TContext
> => {
  const mutationOptions = getCreatePosMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Searches by searchstring and returns all available point of sales for the given audiologist.

 * @summary Searches by searchstring and returns all available point of sales
 */
export type searchAllPosResponse = {
  data: PosListItemDTO[];
  status: number;
};

export const getSearchAllPosUrl = (
  audiologistId: string,
  params?: SearchAllPosParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `http://localhost:8080/platform/v1/audiologists/${audiologistId}/pos/search?${normalizedParams.toString()}`
    : `http://localhost:8080/platform/v1/audiologists/${audiologistId}/pos/search`;
};

export const searchAllPos = async (
  audiologistId: string,
  params?: SearchAllPosParams,
  options?: RequestInit
): Promise<searchAllPosResponse> => {
  return customFetchInstance<Promise<searchAllPosResponse>>(
    getSearchAllPosUrl(audiologistId, params),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getSearchAllPosQueryKey = (
  audiologistId: string,
  params?: SearchAllPosParams
) => {
  return [
    `http://localhost:8080/platform/v1/audiologists/${audiologistId}/pos/search`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchAllPosQueryOptions = <
  TData = Awaited<ReturnType<typeof searchAllPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: SearchAllPosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchAllPos>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchAllPosQueryKey(audiologistId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAllPos>>> = ({
    signal,
  }) => searchAllPos(audiologistId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!audiologistId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof searchAllPos>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchAllPosQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchAllPos>>
>;
export type SearchAllPosQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useSearchAllPos<
  TData = Awaited<ReturnType<typeof searchAllPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params: undefined | SearchAllPosParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchAllPos>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAllPos>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSearchAllPos<
  TData = Awaited<ReturnType<typeof searchAllPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: SearchAllPosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchAllPos>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAllPos>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSearchAllPos<
  TData = Awaited<ReturnType<typeof searchAllPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: SearchAllPosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchAllPos>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Searches by searchstring and returns all available point of sales
 */

export function useSearchAllPos<
  TData = Awaited<ReturnType<typeof searchAllPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: SearchAllPosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchAllPos>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchAllPosQueryOptions(
    audiologistId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSearchAllPosSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof searchAllPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: SearchAllPosParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof searchAllPos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchAllPosQueryKey(audiologistId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAllPos>>> = ({
    signal,
  }) => searchAllPos(audiologistId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!audiologistId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof searchAllPos>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchAllPosSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchAllPos>>
>;
export type SearchAllPosSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useSearchAllPosSuspense<
  TData = Awaited<ReturnType<typeof searchAllPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params: undefined | SearchAllPosParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof searchAllPos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSearchAllPosSuspense<
  TData = Awaited<ReturnType<typeof searchAllPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: SearchAllPosParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof searchAllPos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSearchAllPosSuspense<
  TData = Awaited<ReturnType<typeof searchAllPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: SearchAllPosParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof searchAllPos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Searches by searchstring and returns all available point of sales
 */

export function useSearchAllPosSuspense<
  TData = Awaited<ReturnType<typeof searchAllPos>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  params?: SearchAllPosParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof searchAllPos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchAllPosSuspenseQueryOptions(
    audiologistId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a specific pos by id
 * @summary Returns a specific pos
 */
export type getPosByIdResponse = {
  data: PosDTO;
  status: number;
};

export const getGetPosByIdUrl = (audiologistId: string, posId: string) => {
  return `http://localhost:8080/platform/v1/audiologists/${audiologistId}/pos/${posId}`;
};

export const getPosById = async (
  audiologistId: string,
  posId: string,
  options?: RequestInit
): Promise<getPosByIdResponse> => {
  return customFetchInstance<Promise<getPosByIdResponse>>(
    getGetPosByIdUrl(audiologistId, posId),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetPosByIdQueryKey = (audiologistId: string, posId: string) => {
  return [
    `http://localhost:8080/platform/v1/audiologists/${audiologistId}/pos/${posId}`,
  ] as const;
};

export const getGetPosByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPosById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  posId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPosById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPosByIdQueryKey(audiologistId, posId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPosById>>> = ({
    signal,
  }) => getPosById(audiologistId, posId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(audiologistId && posId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPosById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPosByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPosById>>
>;
export type GetPosByIdQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetPosById<
  TData = Awaited<ReturnType<typeof getPosById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  posId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPosById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPosById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPosById<
  TData = Awaited<ReturnType<typeof getPosById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  posId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPosById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPosById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPosById<
  TData = Awaited<ReturnType<typeof getPosById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  posId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPosById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a specific pos
 */

export function useGetPosById<
  TData = Awaited<ReturnType<typeof getPosById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  posId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPosById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPosByIdQueryOptions(audiologistId, posId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPosByIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPosById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  posId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPosById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPosByIdQueryKey(audiologistId, posId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPosById>>> = ({
    signal,
  }) => getPosById(audiologistId, posId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(audiologistId && posId),
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPosById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPosByIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPosById>>
>;
export type GetPosByIdSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetPosByIdSuspense<
  TData = Awaited<ReturnType<typeof getPosById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  posId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPosById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPosByIdSuspense<
  TData = Awaited<ReturnType<typeof getPosById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  posId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPosById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPosByIdSuspense<
  TData = Awaited<ReturnType<typeof getPosById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  posId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPosById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a specific pos
 */

export function useGetPosByIdSuspense<
  TData = Awaited<ReturnType<typeof getPosById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  posId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPosById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPosByIdSuspenseQueryOptions(
    audiologistId,
    posId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates a pos
 * @summary Updates a pos
 */
export type updatePosByIdResponse = {
  data: PosDTO;
  status: number;
};

export const getUpdatePosByIdUrl = (audiologistId: string, posId: string) => {
  return `http://localhost:8080/platform/v1/audiologists/${audiologistId}/pos/${posId}`;
};

export const updatePosById = async (
  audiologistId: string,
  posId: string,
  posUpdateDTO: PosUpdateDTO,
  options?: RequestInit
): Promise<updatePosByIdResponse> => {
  return customFetchInstance<Promise<updatePosByIdResponse>>(
    getUpdatePosByIdUrl(audiologistId, posId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(posUpdateDTO),
    }
  );
};

export const getUpdatePosByIdMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePosById>>,
    TError,
    { audiologistId: string; posId: string; data: PosUpdateDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePosById>>,
  TError,
  { audiologistId: string; posId: string; data: PosUpdateDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePosById>>,
    { audiologistId: string; posId: string; data: PosUpdateDTO }
  > = (props) => {
    const { audiologistId, posId, data } = props ?? {};

    return updatePosById(audiologistId, posId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePosByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePosById>>
>;
export type UpdatePosByIdMutationBody = PosUpdateDTO;
export type UpdatePosByIdMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Updates a pos
 */
export const useUpdatePosById = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePosById>>,
    TError,
    { audiologistId: string; posId: string; data: PosUpdateDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePosById>>,
  TError,
  { audiologistId: string; posId: string; data: PosUpdateDTO },
  TContext
> => {
  const mutationOptions = getUpdatePosByIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Deletes a specific pos by id.
 * @summary Deletes a specific pos.
 */
export type deletePosByIdResponse = {
  data: DeleteSuccessDTO;
  status: number;
};

export const getDeletePosByIdUrl = (audiologistId: string, posId: string) => {
  return `http://localhost:8080/platform/v1/audiologists/${audiologistId}/pos/${posId}`;
};

export const deletePosById = async (
  audiologistId: string,
  posId: string,
  options?: RequestInit
): Promise<deletePosByIdResponse> => {
  return customFetchInstance<Promise<deletePosByIdResponse>>(
    getDeletePosByIdUrl(audiologistId, posId),
    {
      ...options,
      method: "DELETE",
    }
  );
};

export const getDeletePosByIdMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | void
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePosById>>,
    TError,
    { audiologistId: string; posId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePosById>>,
  TError,
  { audiologistId: string; posId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePosById>>,
    { audiologistId: string; posId: string }
  > = (props) => {
    const { audiologistId, posId } = props ?? {};

    return deletePosById(audiologistId, posId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePosByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePosById>>
>;

export type DeletePosByIdMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | void
  | InternalServerErrorResponse;

/**
 * @summary Deletes a specific pos.
 */
export const useDeletePosById = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | void
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePosById>>,
    TError,
    { audiologistId: string; posId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePosById>>,
  TError,
  { audiologistId: string; posId: string },
  TContext
> => {
  const mutationOptions = getDeletePosByIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Returns all available PointOfSaleCustomerNumbers for the given audiologist.

 * @summary Returns all available PointOfSaleCustomerNumbers
 */
export type getAllAvailablePointOfSaleCustomerNumbersResponse = {
  data: PosCustomerNumberGetDTO[];
  status: number;
};

export const getGetAllAvailablePointOfSaleCustomerNumbersUrl = (
  audiologistId: string
) => {
  return `http://localhost:8080/platform/v1/audiologists/${audiologistId}/pos-customer-numbers`;
};

export const getAllAvailablePointOfSaleCustomerNumbers = async (
  audiologistId: string,
  options?: RequestInit
): Promise<getAllAvailablePointOfSaleCustomerNumbersResponse> => {
  return customFetchInstance<
    Promise<getAllAvailablePointOfSaleCustomerNumbersResponse>
  >(getGetAllAvailablePointOfSaleCustomerNumbersUrl(audiologistId), {
    ...options,
    method: "GET",
  });
};

export const getGetAllAvailablePointOfSaleCustomerNumbersQueryKey = (
  audiologistId: string
) => {
  return [
    `http://localhost:8080/platform/v1/audiologists/${audiologistId}/pos-customer-numbers`,
  ] as const;
};

export const getGetAllAvailablePointOfSaleCustomerNumbersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAllAvailablePointOfSaleCustomerNumbersQueryKey(audiologistId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>
  > = ({ signal }) =>
    getAllAvailablePointOfSaleCustomerNumbers(audiologistId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!audiologistId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllAvailablePointOfSaleCustomerNumbersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>
>;
export type GetAllAvailablePointOfSaleCustomerNumbersQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetAllAvailablePointOfSaleCustomerNumbers<
  TData = Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAllAvailablePointOfSaleCustomerNumbers<
  TData = Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAllAvailablePointOfSaleCustomerNumbers<
  TData = Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns all available PointOfSaleCustomerNumbers
 */

export function useGetAllAvailablePointOfSaleCustomerNumbers<
  TData = Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAllAvailablePointOfSaleCustomerNumbersQueryOptions(
    audiologistId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAllAvailablePointOfSaleCustomerNumbersSuspenseQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>
    >,
    TError =
      | BadRequestResponse
      | UnauthorizedResponse
      | ForbiddenResponse
      | InternalServerErrorResponse,
  >(
    audiologistId: string,
    options?: {
      query?: Partial<
        UseSuspenseQueryOptions<
          Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customFetchInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAllAvailablePointOfSaleCustomerNumbersQueryKey(audiologistId);

    const queryFn: QueryFunction<
      Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>
    > = ({ signal }) =>
      getAllAvailablePointOfSaleCustomerNumbers(audiologistId, {
        signal,
        ...requestOptions,
      });

    return {
      queryKey,
      queryFn,
      enabled: !!audiologistId,
      ...queryOptions,
    } as UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type GetAllAvailablePointOfSaleCustomerNumbersSuspenseQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>
  >;
export type GetAllAvailablePointOfSaleCustomerNumbersSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetAllAvailablePointOfSaleCustomerNumbersSuspense<
  TData = Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAllAvailablePointOfSaleCustomerNumbersSuspense<
  TData = Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetAllAvailablePointOfSaleCustomerNumbersSuspense<
  TData = Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns all available PointOfSaleCustomerNumbers
 */

export function useGetAllAvailablePointOfSaleCustomerNumbersSuspense<
  TData = Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllAvailablePointOfSaleCustomerNumbers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetAllAvailablePointOfSaleCustomerNumbersSuspenseQueryOptions(
      audiologistId,
      options
    );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
